module.exports = __webpack_public_path__ + "static/media/logo-special-edition.c5f1c035.svg";